export function FileUploadImage() {
  return (
    <svg
      width={"104"}
      height={"104"}
      viewBox={"0 0 104 104"}
      fill={"none"}
      xmlns={"http://www.w3.org/2000/svg"}
    >
      <g clipPath={"url(#clip0_1404_10469)"}>
        <path
          d={
            "M2 52C2 24.3858 24.3858 2 52 2C79.6142 2 102 24.3858 102 52C102 79.6142 79.6142 102 52 102C24.3858 102 2 79.6142 2 52Z"
          }
          fill={"#FAFCFC"}
        />
        <g filter={"url(#filter0_d_1404_10469)"}>
          <path
            d={
              "M17 36C17 31.5817 20.5817 28 25 28H79C83.4183 28 87 31.5817 87 36V120C87 124.418 83.4183 128 79 128H25C20.5817 128 17 124.418 17 120V36Z"
            }
            fill={"white"}
          />
          <path
            d={
              "M25 38C25 36.8954 25.8954 36 27 36H48C49.1046 36 50 36.8954 50 38C50 39.1046 49.1046 40 48 40H27C25.8954 40 25 39.1046 25 38Z"
            }
            fill={"#99BDC1"}
          />
          <path
            d={
              "M29 45.5C26.5147 45.5 24.5 47.5147 24.5 50V54C24.5 56.4853 26.5147 58.5 29 58.5H75C77.4853 58.5 79.5 56.4853 79.5 54V50C79.5 47.5147 77.4853 45.5 75 45.5H29Z"
            }
            fill={"white"}
            stroke={"#00ACB1"}
          />
          <path
            d={
              "M25 66C25 64.8954 25.8954 64 27 64H48C49.1046 64 50 64.8954 50 66C50 67.1046 49.1046 68 48 68H27C25.8954 68 25 67.1046 25 66Z"
            }
            fill={"#99BDC1"}
          />
          <path
            d={
              "M29 73.75C26.6528 73.75 24.75 75.6528 24.75 78V82C24.75 84.3472 26.6528 86.25 29 86.25H75C77.3472 86.25 79.25 84.3472 79.25 82V78C79.25 75.6528 77.3472 73.75 75 73.75H29Z"
            }
            fill={"#D5E4E6"}
            stroke={"#99BDC1"}
            strokeWidth={"0.5"}
          />
          <g clipPath={"url(#clip1_1404_10469)"}>
            <path
              d={
                "M67.4543 51.7284C68.0221 52.7095 68.0513 53.8576 67.638 54.8261C67.4501 55.2729 67.1621 55.682 66.7863 56.016L65.6007 53.9661C65.3627 53.7198 64.9786 53.6572 64.6947 53.8409C64.4192 54.0121 64.2898 54.3544 64.3858 54.6717L65.5715 56.7341C65.2709 56.8426 64.9619 56.901 64.6488 56.9136C63.388 56.9845 62.1356 56.3583 61.4634 55.1894C60.5074 53.5361 61.0751 51.4195 62.7326 50.4634C64.3858 49.5074 66.5024 50.0752 67.4585 51.7284H67.4543Z"
              }
              fill={"#CAF0C1"}
            />
            <path
              d={
                "M66.1517 52.4841C66.3479 52.8264 66.4314 53.2021 66.4106 53.5695C66.3897 53.962 66.2477 54.3419 66.0056 54.6592L65.6048 53.9661C65.3669 53.7198 64.9828 53.6572 64.6989 53.8409C64.4233 54.0121 64.2939 54.3544 64.3899 54.6717L64.7991 55.3772C64.4275 55.4482 64.0392 55.4023 63.7011 55.252C63.3253 55.0975 62.9955 54.8178 62.7743 54.4337C62.2357 53.5027 62.5572 52.3045 63.4882 51.766C64.4233 51.2233 65.6173 51.5489 66.1559 52.4799L66.1517 52.4841Z"
              }
              fill={"#015D67"}
            />
            <path
              d={
                "M77.4072 58.7923L74.9357 54.5047C74.9357 54.5047 74.9148 54.4755 74.9023 54.4588C74.5808 54.033 74.0882 53.7992 73.5872 53.7992C73.3451 53.7992 73.1029 53.8534 72.8775 53.9662C72.6145 54.0998 72.4016 54.296 72.2513 54.5339C71.7461 53.9787 70.8903 53.8326 70.2306 54.225C69.9885 54.3711 69.7965 54.5715 69.6629 54.8011C69.1452 54.392 68.4021 54.3252 67.8218 54.6842C67.7591 54.7218 67.7007 54.7636 67.6464 54.8095C67.5212 54.9055 67.4168 55.0224 67.3291 55.1476L66.4065 53.5487L66.3647 53.4735C66.3522 53.4485 66.3355 53.4276 66.3146 53.4067C65.797 52.8014 64.8952 52.6553 64.223 53.0686C63.5759 53.4694 63.2879 54.2834 63.5425 55.0057C63.5509 55.0307 63.5634 55.06 63.5801 55.0808L63.672 55.2395L64.6322 56.9136L66.7947 60.6793L66.2771 60.337C65.7385 59.9821 65.0914 59.8569 64.461 59.9863C63.8264 60.1157 63.2837 60.4831 62.9288 61.0217C62.8119 61.2012 62.7702 61.4141 62.8119 61.6228C62.8537 61.8358 62.9748 62.0153 63.1459 62.1238L67.78 65.376C68.8279 66.1108 70.0637 66.4824 71.3036 66.4824C72.364 66.4824 73.4244 66.211 74.3721 65.6641L75.7832 64.8458C77.8998 63.6268 78.6304 60.9089 77.4072 58.7923ZM75.3281 64.0526L73.9129 64.8709C72.1636 65.8812 69.9593 65.7852 68.306 64.6246L63.7554 61.435C63.9767 61.1511 64.2898 60.9549 64.6447 60.8839C65.0371 60.8046 65.4379 60.8797 65.7719 61.101L67.8969 62.4996C68.0764 62.6123 68.3102 62.5914 68.4647 62.4495C68.6192 62.3033 68.6525 62.0695 68.5482 61.8859L64.3942 54.6675C64.3024 54.3586 64.4276 54.0163 64.7031 53.8493C64.9829 53.6739 65.3628 53.7282 65.5966 53.9745L67.0536 56.5003L67.2081 56.7675C67.3291 56.9762 67.5963 57.0555 67.8134 56.947C68.0305 56.8343 68.1223 56.5754 68.0221 56.3542C68.018 56.3458 68.0138 56.3375 68.0138 56.3291C67.8844 56.0077 68.0054 55.6403 68.2977 55.4649C68.5941 55.2812 68.9949 55.3606 69.2162 55.6403L69.283 55.7572C69.283 55.7572 69.2871 55.7697 69.2913 55.7739L69.6378 56.3709C69.7631 56.5838 70.0344 56.6631 70.2515 56.542C70.4686 56.4251 70.5521 56.1538 70.4394 55.9325V55.92C70.2807 55.5985 70.3976 55.1936 70.6982 55.014C71.0197 54.8262 71.4414 54.9264 71.6292 55.2186L72.1469 56.1162C72.1469 56.1162 72.1553 56.1287 72.1594 56.1329C72.2847 56.3291 72.5393 56.4001 72.7481 56.2957C72.9652 56.1914 73.0612 55.9325 72.9652 55.7112C72.961 55.6987 72.9568 55.6904 72.9568 55.6778C72.9234 55.5985 72.9067 55.5109 72.9067 55.4274C72.9067 55.1602 73.0487 54.9055 73.2866 54.7886C73.5747 54.6425 73.9463 54.7302 74.155 54.9932L76.614 59.2473C77.5826 60.9298 77.0064 63.084 75.3281 64.0526Z"
              }
              fill={"#00ACB1"}
            />
            <path
              d={
                "M75.3283 64.0525L73.913 64.8708C72.1638 65.8811 69.9594 65.7851 68.3062 64.6245L63.7556 61.4349C63.9769 61.151 64.29 60.9548 64.6449 60.8838C65.0373 60.8045 65.4381 60.8797 65.7721 61.1009L67.8971 62.4995C68.0766 62.6122 68.3104 62.5913 68.4648 62.4494C68.6193 62.3033 68.6527 62.0695 68.5483 61.8858L64.3944 54.6675C64.3025 54.3585 64.4278 54.0162 64.7033 53.8492C64.983 53.6739 65.3629 53.7281 65.5967 53.9744L67.0537 56.5002L67.2082 56.7674L68.7654 59.4602C68.8489 59.6063 69.0034 59.6898 69.162 59.6898C69.2372 59.6898 69.3165 59.6689 69.3917 59.6272C69.6088 59.502 69.6839 59.2222 69.5587 59.001L68.014 56.3291C67.8845 56.0076 68.0056 55.6402 68.2979 55.4649C68.5943 55.2812 68.9951 55.3605 69.2163 55.6402L69.2831 55.7571C69.2831 55.7571 69.2873 55.7696 69.2915 55.7738L69.638 56.3708L70.7568 58.3079C70.8445 58.4582 70.9948 58.5376 71.1535 58.5376C71.2328 58.5376 71.3121 58.5209 71.3831 58.4791C71.6043 58.3497 71.6795 58.07 71.5501 57.8529L70.4396 55.9325V55.9199C70.2809 55.5985 70.3978 55.1935 70.6984 55.014C71.0199 54.8261 71.4415 54.9263 71.6294 55.2186L72.1471 56.1161C72.1471 56.1161 72.1554 56.1287 72.1596 56.1328L72.7524 57.1599C72.8359 57.306 72.9904 57.3853 73.149 57.3853C73.2284 57.3853 73.3077 57.3686 73.3786 57.3269C73.5957 57.1974 73.6709 56.9177 73.5456 56.7006L72.957 55.6778C72.9236 55.5985 72.9069 55.5108 72.9069 55.4273C72.9069 55.1601 73.0488 54.9054 73.2868 54.7885C73.5749 54.6424 73.9464 54.7301 74.1552 54.9931L76.6142 59.2473C77.5827 60.9298 77.0066 63.084 75.3283 64.0525Z"
              }
              fill={"white"}
            />
            <path
              d={
                "M69.3915 59.6273C69.3163 59.669 69.237 59.6899 69.1618 59.6899C69.0032 59.6899 68.8487 59.6064 68.7652 59.4603L67.208 56.7675L67.0535 56.5003C66.9283 56.2832 67.0034 56.0035 67.2205 55.8741C67.4418 55.7489 67.7215 55.824 67.8468 56.0411L68.0138 56.3292L69.5585 59.0011C69.6837 59.2223 69.6086 59.502 69.3915 59.6273Z"
              }
              fill={"#00ACB1"}
            />
            <path
              d={
                "M71.3829 58.4791C71.312 58.5208 71.2327 58.5375 71.1533 58.5375C70.9947 58.5375 70.8444 58.4582 70.7567 58.3079L69.6379 56.3708L69.2913 55.7738C69.2913 55.7738 69.283 55.7612 69.283 55.7571C69.1703 55.54 69.2454 55.2686 69.4625 55.1475C69.6796 55.0223 69.9593 55.0974 70.0846 55.3145L70.4353 55.9199V55.9324L71.5499 57.8528C71.6794 58.0699 71.6042 58.3497 71.3829 58.4791Z"
              }
              fill={"#00ACB1"}
            />
            <path
              d={
                "M73.3785 57.3268C73.3075 57.3686 73.2282 57.3853 73.1489 57.3853C72.9902 57.3853 72.8357 57.3059 72.7522 57.1598L72.1594 56.1328L71.6543 55.2561C71.529 55.0348 71.6042 54.7551 71.8212 54.6299C72.0425 54.5004 72.3222 54.5798 72.4475 54.7969L72.9568 55.6778L73.5455 56.7006C73.6707 56.9177 73.5956 57.1974 73.3785 57.3268Z"
              }
              fill={"#00ACB1"}
            />
          </g>
          <path
            d={
              "M25 27.75C20.4437 27.75 16.75 31.4436 16.75 36V120C16.75 124.556 20.4437 128.25 25 128.25H79C83.5564 128.25 87.25 124.556 87.25 120V36C87.25 31.4437 83.5564 27.75 79 27.75H25Z"
            }
            stroke={"#D5E4E6"}
            strokeWidth={"0.5"}
          />
        </g>
        <g filter={"url(#filter1_d_1404_10469)"}>
          <circle cx={"39.5"} cy={"20"} r={"2.5"} fill={"#D5E4E6"} />
        </g>
        <circle cx={"52.5"} cy={"20"} r={"2.5"} fill={"#00ACB1"} />
        <g filter={"url(#filter2_d_1404_10469)"}>
          <circle cx={"65.5"} cy={"20"} r={"2.5"} fill={"#D5E4E6"} />
        </g>
      </g>
      <path
        d={
          "M52 1.35C24.0268 1.35 1.35 24.0268 1.35 52C1.35 79.9732 24.0268 102.65 52 102.65C79.9732 102.65 102.65 79.9732 102.65 52C102.65 24.0268 79.9732 1.35 52 1.35Z"
        }
        stroke={"#D5E4E6"}
        strokeWidth={"1.3"}
      />
      <defs>
        <filter
          id={"filter0_d_1404_10469"}
          x={"-3.5"}
          y={"7.5"}
          width={"111"}
          height={"141"}
          filterUnits={"userSpaceOnUse"}
          colorInterpolationFilters={"sRGB"}
        >
          <feFlood floodOpacity={"0"} result={"BackgroundImageFix"} />
          <feColorMatrix
            in={"SourceAlpha"}
            type={"matrix"}
            values={"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"}
            result={"hardAlpha"}
          />
          <feOffset />
          <feGaussianBlur stdDeviation={"10"} />
          <feComposite in2={"hardAlpha"} operator={"out"} />
          <feColorMatrix
            type={"matrix"}
            values={
              "0 0 0 0 0.835294 0 0 0 0 0.894118 0 0 0 0 0.901961 0 0 0 0.2 0"
            }
          />
          <feBlend
            mode={"normal"}
            in2={"BackgroundImageFix"}
            result={"effect1_dropShadow_1404_10469"}
          />
          <feBlend
            mode={"normal"}
            in={"SourceGraphic"}
            in2={"effect1_dropShadow_1404_10469"}
            result={"shape"}
          />
        </filter>
        <filter
          id={"filter1_d_1404_10469"}
          x={"-3"}
          y={"-22.5"}
          width={"85"}
          height={"85"}
          filterUnits={"userSpaceOnUse"}
          colorInterpolationFilters={"sRGB"}
        >
          <feFlood floodOpacity={"0"} result={"BackgroundImageFix"} />
          <feColorMatrix
            in={"SourceAlpha"}
            type={"matrix"}
            values={"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"}
            result={"hardAlpha"}
          />
          <feOffset />
          <feGaussianBlur stdDeviation={"20"} />
          <feComposite in2={"hardAlpha"} operator={"out"} />
          <feColorMatrix
            type={"matrix"}
            values={
              "0 0 0 0 0.835294 0 0 0 0 0.894118 0 0 0 0 0.901961 0 0 0 0.4 0"
            }
          />
          <feBlend
            mode={"normal"}
            in2={"BackgroundImageFix"}
            result={"effect1_dropShadow_1404_10469"}
          />
          <feBlend
            mode={"normal"}
            in={"SourceGraphic"}
            in2={"effect1_dropShadow_1404_10469"}
            result={"shape"}
          />
        </filter>
        <filter
          id={"filter2_d_1404_10469"}
          x={"23"}
          y={"-22.5"}
          width={"85"}
          height={"85"}
          filterUnits={"userSpaceOnUse"}
          colorInterpolationFilters={"sRGB"}
        >
          <feFlood floodOpacity={"0"} result={"BackgroundImageFix"} />
          <feColorMatrix
            in={"SourceAlpha"}
            type={"matrix"}
            values={"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"}
            result={"hardAlpha"}
          />
          <feOffset />
          <feGaussianBlur stdDeviation={"20"} />
          <feComposite in2={"hardAlpha"} operator={"out"} />
          <feColorMatrix
            type={"matrix"}
            values={
              "0 0 0 0 0.835294 0 0 0 0 0.894118 0 0 0 0 0.901961 0 0 0 0.4 0"
            }
          />
          <feBlend
            mode={"normal"}
            in2={"BackgroundImageFix"}
            result={"effect1_dropShadow_1404_10469"}
          />
          <feBlend
            mode={"normal"}
            in={"SourceGraphic"}
            in2={"effect1_dropShadow_1404_10469"}
            result={"shape"}
          />
        </filter>
        <clipPath id={"clip0_1404_10469"}>
          <path
            d={
              "M2 52C2 24.3858 24.3858 2 52 2C79.6142 2 102 24.3858 102 52C102 79.6142 79.6142 102 52 102C24.3858 102 2 79.6142 2 52Z"
            }
            fill={"white"}
          />
        </clipPath>
        <clipPath id={"clip1_1404_10469"}>
          <rect
            width={"17"}
            height={"16.4823"}
            fill={"white"}
            transform={"translate(61 50)"}
          />
        </clipPath>
      </defs>
    </svg>
  );
}
